import { useContext, useEffect } from "react";
import { SOCKET_EVENTS, SocketContext } from "../components/SocketProvider";
import PersonalAccount from "../store/PersonalAccount";

export default function useRefreshGameData() {
  const { socket } = useContext(SocketContext);

  const onRefreshGameData = async (response) => {;
    const user = PersonalAccount.user;
    if (user) {
      if (user.id === response.invitedUserData.id) {
        PersonalAccount.setPersonalAccountData(response.invitedUserData);
      } else {
        PersonalAccount.setPersonalAccountData(response.inviterUserData);
      }
    }
  };

  useEffect(() => {
    socket.current.on(SOCKET_EVENTS.REFRESH_GAME_DATA_MESSAGE, onRefreshGameData);
    return () => {
      socket.current.off(SOCKET_EVENTS.REFRESH_GAME_DATA_MESSAGE, onRefreshGameData);
    };
  }, [socket]);
}
